import { PropsWithChildren, FC } from 'react';

interface IParagraph extends PropsWithChildren {
    disabled?: boolean,
    className?: string,
}

export const Paragraph: FC<IParagraph> = ({ children, className }) => {
    return <>
        <p className={`colored ${className}`}>{children}</p>
    </>;
};